module.exports = __webpack_public_path__ + "img/no-results.3fdb39e2.svg";